import { createSocketBase } from "@/store/apis/socket.factory"
import { setMaintenance } from "@/store/slices/app"
import { IMaintenanceResponse, MAINTENANCE_SOCKETS } from "./maintenance.types"

export const socketMaintenance = {
  ...createSocketBase("system"),
  updateData: null as
    | ((updater: (draft: IMaintenanceResponse) => void) => void)
    | null,

  init() {
    this._init()
  },

  setUpdateData(
    updateCachedData: (updater: (draft: IMaintenanceResponse) => void) => void
  ) {
    this.updateData = updateCachedData
  },

  bindMaintenanceListener() {
    const handler = (event: IMaintenanceResponse) => {
      console.log("eventData", event)

      this.updateData?.(() => {
        return event
      })

      this.dispatch?.(setMaintenance(event))
    }
    return this._bind(MAINTENANCE_SOCKETS.MAINTENANCE_CHANGED, handler)
  }
}
